import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { customerAuthApi, customerTokenStore } from "@/lib/customerAuth";

const CustomerAuthCtx = createContext({
  user: null,
  loading: true,
  refresh: async () => {},
  logout: async () => {},
  setUser: () => {},
});

export function CustomerAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const me = await customerAuthApi.me();
      setUser(me);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If we're returning from OAuth, AuthCallback will populate the session
    // first. Skip the /me hit here to avoid a 401 race.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    try { await customerAuthApi.logout(); } catch {}
    customerTokenStore.clear();
    setUser(null);
  }, []);

  return (
    <CustomerAuthCtx.Provider value={{ user, loading, refresh, logout, setUser }}>
      {children}
    </CustomerAuthCtx.Provider>
  );
}

export function useCustomerAuth() {
  return useContext(CustomerAuthCtx);
}
